'use client'

import Modal from '../Modal'
import { useState } from 'react'

const NoCredentialsRequiredModal = () => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Modal open={isOpen} onOpenChange={setIsOpen}>
      <Modal.Content title="Login for Demonstration Only">
        <p className="text-center">No username or password needed</p>
      </Modal.Content>
    </Modal>
  )
}

export default NoCredentialsRequiredModal
